import axios from 'axios';

const USER_TOKENS_API = `${process.env.VUE_APP_API_URL}/u1/tokens`;
const USER_DATA_API = `${process.env.VUE_APP_API_URL}/u1/data`;

export const createToken = (appId) => axios.post(`${USER_TOKENS_API}`, { appId });
export const getDataList = (token) => axios.get(`${USER_DATA_API}/${token}`, { params: { token } });
export const removeDataEntry = (token, dataId) => axios.delete(`${USER_DATA_API}/${token}/${dataId}`);
export const removeDataEntries = (token, dataIds) => axios.delete(`${USER_DATA_API}/${token}`, { data: { dataIds } });
